<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'

import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const error = computed(() => {
  const e = props.error
  if (e.statusCode === 404 || e.statusCode === 410) {
    e.statusMessage = 'Page introuvable'
  }
  if (e.statusMessage === 'Server Error') {
    e.statusMessage = 'Erreur'
  }
  e.message = e.statusMessage
  return e
})

const platform = useSiteConfig().platform
</script>

<template>
  <PlatformApp>
    <UApp :locale="fr">
      <div :class="[platform.menu?.length && 'header-with-menu']">
        <Header />
        <UMain>
          <UError :error="error" />
        </UMain>
        <Footer />
      </div>
    </UApp>
  </PlatformApp>
</template>